import React from "react";
import TermsSection from "./termSection.js";
import termsData from "./termsData.js";
import './terms.css';

export function Terms() {

  return (

    <div className="terms-container">


      <h3>
        Welcome to Edsider.
      </h3>


      <p>
        These Terms & Conditions govern your use of this online examination
        platform. By accessing or using the platform, you agree to comply with
        these terms to facilitate a fair, secure, and reliable examination
        experience for all parties involved.
      </p>


      <p>
        Please read them carefully before proceeding.
      </p>


      {
        termsData.map((section, index) => (

          <TermsSection
            key={index}
            number={index + 1}
            title={section.title}
            description={section.description}
            points={section.points}
          />

        ))
      }

      <p><b>Before you continue</b></p>
      <p>By clicking Accept, you confirm that you have read and understood these Terms & Conditions and agree to follow them while using the online examination platform. </p>

    </div>
  );
}